export default __webpack_public_path__ + "static/media/gallery08.46d13481.JPG";